import { render } from "./CardBox.vue?vue&type=template&id=780db6ec&scoped=true"
import script from "./CardBox.vue?vue&type=script&lang=js"
export * from "./CardBox.vue?vue&type=script&lang=js"

import "./CardBox.vue?vue&type=style&index=0&id=780db6ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780db6ec"]])

export default __exports__